
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9zbN", function(module, exports) {
$parcel$export(module.exports, "GlobalCreateContentPopover", () => (parcelRequire("aQZ08")).GlobalCreateContentPopover);
$parcel$export(module.exports, "GlobalCreateContentButton", () => (parcelRequire("gsXbX")).GlobalCreateContentButton);
$parcel$export(module.exports, "ContextualCreateContentPopover", () => (parcelRequire("2to2n")).ContextualCreateContentPopover);
$parcel$export(module.exports, "contextualCreateContentIconSVGColor", () => (parcelRequire("cDCEW")).contextualCreateContentIconSVGColor);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $aQZ08 = parcelRequire("aQZ08");


var $gsXbX = parcelRequire("gsXbX");


var $2to2n = parcelRequire("2to2n");


var $cDCEW = parcelRequire("cDCEW");


});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("gsXbX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $jmjWc = parcelRequire("jmjWc");


var $6PMed = parcelRequire("6PMed");


var $lLaRd = parcelRequire("lLaRd");


const $18414c638d573189$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xnuWz",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("gWntw"))).CreateButton
});
const $18414c638d573189$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create.content.popover.button",
        defaultMessage: "Create"
    },
    createContentLabel: {
        id: "create-blank-fabric-page.create.content.aria.label",
        defaultMessage: "Create content"
    }
});
const $18414c638d573189$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $18414c638d573189$export$dff01287f8ba179f = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { triggerProps: triggerProps, onClick: onClick } = t0;
    const { ref: ref } = triggerProps;
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    let t1;
    if ($[0] !== onClick) {
        t1 = ()=>{
            onClick();
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateButton, {
            onClick: handleClick,
            testId: "create-content-popover-button"
        }, t2);
        $[3] = handleClick;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== preloadCreationMenuData || $[6] !== ref || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.CreateContentButtonWrapper), {
            "data-vc": "create-content-button-wrapper",
            ref: ref,
            onMouseEnter: preloadCreationMenuData,
            onFocus: preloadCreationMenuData
        }, t3);
        $[5] = preloadCreationMenuData;
        $[6] = ref;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
module.exports["GlobalCreateContentButton"] = $18414c638d573189$export$dff01287f8ba179f;

});

parcelRegister("6PMed", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $eVXGa = parcelRequire("eVXGa");

const $bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = (0, $eSUdr.default)`query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
const $bd992de7e8ae5757$export$305839d0d8489bf4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const [preloadWhiteboardPaywallData] = (0, $jxs8y.useLazyQuery)($bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery);
    const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
    return (0, $42omo.useCallback)(()=>{
        if (shouldPreloadPaywallData) preloadWhiteboardPaywallData();
    }, [
        preloadWhiteboardPaywallData,
        shouldPreloadPaywallData
    ]);
};
module.exports["usePreloadCreationMenuData"] = $bd992de7e8ae5757$export$305839d0d8489bf4;

});

parcelRegister("lLaRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $35d2916df5304fc4$export$feec4094f6279c08 = 1129;
const $35d2916df5304fc4$export$be58b4326e23250f = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35d2916df5304fc4$export$bfe3a25e72ae6442 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1y3ozwfg _1qbpzwfg _7bqgzwfg _9kv71tcg _1i0i1tcg _1f1h1tcg _859hu2gc _1wkzu2gc _bgw9u2gc _1n3cidpf _113jidpf _1kzlidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["CreateContentButtonWrapper"] = $35d2916df5304fc4$export$bfe3a25e72ae6442;

});

parcelRegister("gWntw", function(module, exports) {

let $c55445ca5243fd9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c55445ca5243fd9a$var$load("iYF63"),
    $c55445ca5243fd9a$var$load("6wr18"),
    $c55445ca5243fd9a$var$load("kFEyO"),
    $c55445ca5243fd9a$var$load("iBQD9"),
    $c55445ca5243fd9a$var$load("hLjS5"),
    $c55445ca5243fd9a$var$load("48rvp"),
    $c55445ca5243fd9a$var$load("iMSgb"),
    $c55445ca5243fd9a$var$load("ffEVr"),
    $c55445ca5243fd9a$var$load("7EorR"),
    $c55445ca5243fd9a$var$load("hhss7"),
    $c55445ca5243fd9a$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("7zzOq", function(module, exports) {

let $583794e17be8a388$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $583794e17be8a388$var$load("7Ftdh"),
    $583794e17be8a388$var$load("fuKGN"),
    $583794e17be8a388$var$load("4IYLb"),
    $583794e17be8a388$var$load("7oiUM"),
    $583794e17be8a388$var$load("8t3po"),
    $583794e17be8a388$var$load("6wr18"),
    $583794e17be8a388$var$load("aDPqY"),
    $583794e17be8a388$var$load("3gTFx"),
    $583794e17be8a388$var$load("7QQL7"),
    $583794e17be8a388$var$load("lnk1B"),
    $583794e17be8a388$var$load("gr6JX"),
    $583794e17be8a388$var$load("hOaAV"),
    $583794e17be8a388$var$load("iAqyW"),
    $583794e17be8a388$var$load("jbxHq"),
    $583794e17be8a388$var$load("cEqm7"),
    $583794e17be8a388$var$load("6XCf4"),
    $583794e17be8a388$var$load("5pvpJ"),
    $583794e17be8a388$var$load("ffEVr"),
    $583794e17be8a388$var$load("1qlDN"),
    $583794e17be8a388$var$load("1yVM6"),
    $583794e17be8a388$var$load("hhss7"),
    $583794e17be8a388$var$load("7EorR"),
    $583794e17be8a388$var$load("4UuEP"),
    $583794e17be8a388$var$load("beE2d"),
    $583794e17be8a388$var$load("dwffN")
]).then(()=>parcelRequire('bvmt1'));

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default));
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $278c8d04dad7bc1d$export$363a8d7f501f3769 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInterop(query, options) {
    const $ = (0, $frIzR.c)(2);
    {
        let t0;
        if ($[0] !== query) {
            t0 = (0, $86okN.toDocumentNode)(query);
            $[0] = query;
            $[1] = t0;
        } else t0 = $[1];
        return (0, $jxs8y.useLazyQuery)(t0, options);
    }
} : function useLazyQueryInterop(query, options) {
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
};
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("dNm5z"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("dNm5z", function(module, exports) {

let $a0b0fc570d790d85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0b0fc570d790d85$var$load("a7PxR"),
    $a0b0fc570d790d85$var$load("2vAWg"),
    $a0b0fc570d790d85$var$load("7cABH"),
    $a0b0fc570d790d85$var$load("4UuEP"),
    $a0b0fc570d790d85$var$load("h305A"),
    $a0b0fc570d790d85$var$load("h3ABO"),
    $a0b0fc570d790d85$var$load("9CYct"),
    $a0b0fc570d790d85$var$load("iqTGf"),
    $a0b0fc570d790d85$var$load("cUIaj"),
    $a0b0fc570d790d85$var$load("44eor"),
    $a0b0fc570d790d85$var$load("8faeS"),
    $a0b0fc570d790d85$var$load("fuKGN"),
    $a0b0fc570d790d85$var$load("4IYLb"),
    $a0b0fc570d790d85$var$load("2YffH"),
    $a0b0fc570d790d85$var$load("hRxyC"),
    $a0b0fc570d790d85$var$load("hgBoY"),
    $a0b0fc570d790d85$var$load("9Sp67"),
    $a0b0fc570d790d85$var$load("7Ne1O"),
    $a0b0fc570d790d85$var$load("iIoyG"),
    $a0b0fc570d790d85$var$load("2xn4F"),
    $a0b0fc570d790d85$var$load("1P7J4"),
    $a0b0fc570d790d85$var$load("i1up4"),
    $a0b0fc570d790d85$var$load("fJtJG"),
    $a0b0fc570d790d85$var$load("1GvGi"),
    $a0b0fc570d790d85$var$load("d4u0p"),
    $a0b0fc570d790d85$var$load("4c4ZI"),
    $a0b0fc570d790d85$var$load("fC7SA"),
    $a0b0fc570d790d85$var$load("bUCSn"),
    $a0b0fc570d790d85$var$load("gVbhn"),
    $a0b0fc570d790d85$var$load("aJGJj"),
    $a0b0fc570d790d85$var$load("6DW0g"),
    $a0b0fc570d790d85$var$load("3k469"),
    $a0b0fc570d790d85$var$load("cyGuT"),
    $a0b0fc570d790d85$var$load("3EXzu"),
    $a0b0fc570d790d85$var$load("8pDNY"),
    $a0b0fc570d790d85$var$load("b2FtX"),
    $a0b0fc570d790d85$var$load("7Ftdh"),
    $a0b0fc570d790d85$var$load("e4wOQ"),
    $a0b0fc570d790d85$var$load("3w411"),
    $a0b0fc570d790d85$var$load("dIzOY"),
    $a0b0fc570d790d85$var$load("alXrq"),
    $a0b0fc570d790d85$var$load("7oiUM"),
    $a0b0fc570d790d85$var$load("8t3po"),
    $a0b0fc570d790d85$var$load("855o0"),
    $a0b0fc570d790d85$var$load("8MfZE"),
    $a0b0fc570d790d85$var$load("kjZZD"),
    $a0b0fc570d790d85$var$load("4qa0a"),
    $a0b0fc570d790d85$var$load("iPNfy"),
    $a0b0fc570d790d85$var$load("9u7sS"),
    $a0b0fc570d790d85$var$load("1fem1"),
    $a0b0fc570d790d85$var$load("8hq1F"),
    $a0b0fc570d790d85$var$load("7FF6A"),
    $a0b0fc570d790d85$var$load("k5Ch2"),
    $a0b0fc570d790d85$var$load("djob1"),
    $a0b0fc570d790d85$var$load("9S9Mz"),
    $a0b0fc570d790d85$var$load("6wr18"),
    $a0b0fc570d790d85$var$load("ffEVr"),
    $a0b0fc570d790d85$var$load("Wowvf"),
    $a0b0fc570d790d85$var$load("hhss7"),
    $a0b0fc570d790d85$var$load("dAdaw"),
    $a0b0fc570d790d85$var$load("c0JsV"),
    $a0b0fc570d790d85$var$load("bgHzk"),
    $a0b0fc570d790d85$var$load("7EorR"),
    $a0b0fc570d790d85$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<3713f9ef4d56463a35a603e84cf10cea>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<c4de1f2f464f7c58da863fcc2b8f8310>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<6c06bb421a64deed65b923b9eaef1fcf>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<db055c87cd42b74d8aeb77e7e48c9c82>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<a16e57d7fd38ec5242980bcfc517bf2e>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("5BVCD", function(module, exports) {

let $415d1afc5f884143$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $415d1afc5f884143$var$load("7Ftdh"),
    $415d1afc5f884143$var$load("fuKGN"),
    $415d1afc5f884143$var$load("4IYLb"),
    $415d1afc5f884143$var$load("7oiUM"),
    $415d1afc5f884143$var$load("8t3po"),
    $415d1afc5f884143$var$load("6wr18"),
    $415d1afc5f884143$var$load("4l6Se"),
    $415d1afc5f884143$var$load("aDPqY"),
    $415d1afc5f884143$var$load("3gTFx"),
    $415d1afc5f884143$var$load("lnk1B"),
    $415d1afc5f884143$var$load("gr6JX"),
    $415d1afc5f884143$var$load("hOaAV"),
    $415d1afc5f884143$var$load("iAqyW"),
    $415d1afc5f884143$var$load("1yMtA"),
    $415d1afc5f884143$var$load("jbxHq"),
    $415d1afc5f884143$var$load("8YSo7"),
    $415d1afc5f884143$var$load("cEqm7"),
    $415d1afc5f884143$var$load("6XCf4"),
    $415d1afc5f884143$var$load("5pvpJ"),
    $415d1afc5f884143$var$load("Wowvf"),
    $415d1afc5f884143$var$load("ffEVr"),
    $415d1afc5f884143$var$load("1qlDN"),
    $415d1afc5f884143$var$load("1yVM6"),
    $415d1afc5f884143$var$load("hhss7"),
    $415d1afc5f884143$var$load("6mxDS"),
    $415d1afc5f884143$var$load("3Wg31"),
    $415d1afc5f884143$var$load("henq4"),
    $415d1afc5f884143$var$load("hogcU"),
    $415d1afc5f884143$var$load("4UuEP"),
    $415d1afc5f884143$var$load("dAdaw"),
    $415d1afc5f884143$var$load("b8QJ8"),
    $415d1afc5f884143$var$load("beE2d"),
    $415d1afc5f884143$var$load("7EorR"),
    $415d1afc5f884143$var$load("4Dabn")
]).then(()=>parcelRequire('7yriZ'));

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("jh864", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("aQZ08", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");


var $7EIq6 = parcelRequire("7EIq6");


var $gsXbX = parcelRequire("gsXbX");

const $dc1ea4817175b6dd$export$e961788b96f97626 = ()=>{
    const $ = (0, $frIzR.c)(18);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isOnEditRoute || $[2] !== isOpen || $[3] !== match?.name) {
        t0 = ()=>{
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isOnEditRoute;
        $[2] = isOpen;
        $[3] = match?.name;
        $[4] = t0;
    } else t0 = $[4];
    const onClick = t0;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t1;
    if ($[5] !== isCreateBlogEnabled || $[6] !== isCreateDatabaseEnabled || $[7] !== isCreateLiveDocEnabled || $[8] !== isCreateSmartLinkEnabled || $[9] !== isCreateWhiteboardEnabled) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader, {
                closePopup: ()=>setIsOpen(false),
                isCreateBlogEnabled: isCreateBlogEnabled,
                isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                isCreateSmartLinkEnabled: isCreateSmartLinkEnabled
            });
        $[5] = isCreateBlogEnabled;
        $[6] = isCreateDatabaseEnabled;
        $[7] = isCreateLiveDocEnabled;
        $[8] = isCreateSmartLinkEnabled;
        $[9] = isCreateWhiteboardEnabled;
        $[10] = t1;
    } else t1 = $[10];
    const popupContent = t1;
    let t2;
    if ($[11] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsXbX.GlobalCreateContentButton), {
                onClick: onClick,
                triggerProps: triggerProps
            });
        $[11] = onClick;
        $[12] = t2;
    } else t2 = $[12];
    const popupTrigger = t2;
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== isOpen || $[15] !== popupContent || $[16] !== popupTrigger) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: popupContent,
            trigger: popupTrigger,
            testId: "create-content-popover",
            shouldRenderToParent: true
        });
        $[14] = isOpen;
        $[15] = popupContent;
        $[16] = popupTrigger;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};

const $dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5t0g-",
    name: "GlobalCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("7zzOq"))).GlobalCreateContentPopoverMenu
});
module.exports["GlobalCreateContentPopover"] = $dc1ea4817175b6dd$export$e961788b96f97626;

});

parcelRegister("2to2n", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $lGgRw = parcelRequire("lGgRw");


var $4kfV4 = parcelRequire("4kfV4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $56QzY = parcelRequire("56QzY");


var $lqy4C = parcelRequire("lqy4C");


var $de2j9 = parcelRequire("de2j9");


var $7xVCs = parcelRequire("7xVCs");


var $luv00 = parcelRequire("luv00");


var $6adZX = parcelRequire("6adZX");


var $cbBHq = parcelRequire("cbBHq");


var $7EIq6 = parcelRequire("7EIq6");


var $6PMed = parcelRequire("6PMed");


var $cDCEW = parcelRequire("cDCEW");


var $jmjWc = parcelRequire("jmjWc");


const $c577bd07d81ca8a9$export$bcd38c5b8189fb61 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F0d7H",
    name: "ContextualCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("5BVCD"))).ContextualCreateContentPopoverMenu
});









var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $g5gZt = parcelRequire("g5gZt");


var $9x2sR = parcelRequire("9x2sR");


var $jh864 = parcelRequire("jh864");

const $8c3f789353c0f876$var$addIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    color: "currentColor",
    size: "small"
});
const $8c3f789353c0f876$export$eabe3aa0b599cb62 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClick: onClick, href: href } = t0;
    if (href) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== href || $[2] !== onClick) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                onClick: onClick,
                elemBefore: $8c3f789353c0f876$var$addIcon,
                href: href,
                testId: "tree-create-content-button"
            }, t1);
            $[1] = href;
            $[2] = onClick;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
            onClick: onClick,
            elemBefore: $8c3f789353c0f876$var$addIcon,
            testId: "tree-create-content-button"
        }, t1);
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $8c3f789353c0f876$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create-content-menu-item.create",
        defaultMessage: "Create"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a7a1bff19d06ba1$var$TriggerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0a7a1bff19d06ba1$var$customPopupContainerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    ':focus': {
        outline: 'none'
    }
});
const $0a7a1bff19d06ba1$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, popupRef)=>{
    const $ = (0, $frIzR.c)(9);
    let children;
    let dataTestId;
    let props;
    if ($[0] !== t0) {
        ({ children: children, "data-testid": dataTestId, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = dataTestId;
        $[3] = props;
    } else {
        children = $[1];
        dataTestId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== children || $[5] !== dataTestId || $[6] !== popupRef || $[7] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: dataTestId,
            ...props,
            ref: popupRef,
            xcss: $0a7a1bff19d06ba1$var$customPopupContainerStyles
        }, children);
        $[4] = children;
        $[5] = dataTestId;
        $[6] = popupRef;
        $[7] = props;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
});
const $0a7a1bff19d06ba1$export$79699783f82a969e = (t0)=>{
    const $ = (0, $frIzR.c)(45);
    const { closeAllHoverPageCards: closeAllHoverPageCards, isContextualCreateFocused: isContextualCreateFocused, setIsContextualCreateFocused: setIsContextualCreateFocused, spaceKey: spaceKey, parentId: parentId, source: source, displayTitle: displayTitle, rootCreateButtonStyling: t1, shouldShowPopup: shouldShowPopup, setShouldShowPopup: setShouldShowPopup, isTreeItem: isTreeItem, onItemClick: onItemClick, shouldRenderToParent: shouldRenderToParent, hideFolder: hideFolder, contentType: contentType } = t0;
    const rootCreateButtonStyling = t1 === undefined ? false : t1;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t2;
    if ($[0] !== shouldShowPopup) {
        t2 = ()=>!!shouldShowPopup;
        $[0] = shouldShowPopup;
        $[1] = t2;
    } else t2 = $[1];
    const [isOpen, setIsOpen] = (0, $42omo.useState)(t2);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            source: "page-tree-contextual-create"
        };
        $[2] = t3;
    } else t3 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t3);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    let t4;
    if ($[3] !== preloadCreationMenuData || $[4] !== preloadSmartCreationModal) {
        t4 = ()=>{
            preloadCreationMenuData();
            preloadSmartCreationModal();
            (0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61).preload();
        };
        $[3] = preloadCreationMenuData;
        $[4] = preloadSmartCreationModal;
        $[5] = t4;
    } else t4 = $[5];
    const preloadCreationMenu = t4;
    const stopEvents = $0a7a1bff19d06ba1$var$_temp;
    let t5;
    if ($[6] !== closeFlyout) {
        t5 = (event_0)=>{
            closeFlyout();
            stopEvents(event_0);
        };
        $[6] = closeFlyout;
        $[7] = t5;
    } else t5 = $[7];
    const handleOnClick = t5;
    let t6;
    if ($[8] !== closeAllHoverPageCards || $[9] !== createAnalyticsEvent || $[10] !== isContextualCreateFocused || $[11] !== isOnEditRoute || $[12] !== isOpen || $[13] !== setIsContextualCreateFocused || $[14] !== setShouldShowPopup || $[15] !== source) {
        t6 = ()=>{
            setIsContextualCreateFocused?.(!isContextualCreateFocused);
            closeAllHoverPageCards?.();
            setIsOpen(!isOpen);
            setShouldShowPopup?.(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "contextualCreateButton",
                    actionSubjectId: source,
                    source: "containerNavigation",
                    attributes: {
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[8] = closeAllHoverPageCards;
        $[9] = createAnalyticsEvent;
        $[10] = isContextualCreateFocused;
        $[11] = isOnEditRoute;
        $[12] = isOpen;
        $[13] = setIsContextualCreateFocused;
        $[14] = setShouldShowPopup;
        $[15] = source;
        $[16] = t6;
    } else t6 = $[16];
    const onTriggerClick = t6;
    let t7;
    if ($[17] !== setIsContextualCreateFocused || $[18] !== setShouldShowPopup) {
        t7 = ()=>{
            const activeEle = document.activeElement;
            activeEle?.blur();
            setIsOpen(false);
            setShouldShowPopup?.(false);
            setTimeout(()=>{
                setIsContextualCreateFocused?.(false);
            }, 0);
        };
        $[17] = setIsContextualCreateFocused;
        $[18] = setShouldShowPopup;
        $[19] = t7;
    } else t7 = $[19];
    const onCloseHandler = t7;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateFolderEnabled: isCreateFolderEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t8;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== contentType || $[22] !== displayTitle || $[23] !== enforceStorageLimit || $[24] !== handleOnClick || $[25] !== hideFolder || $[26] !== isContextualCreateFocused || $[27] !== isCreateDatabaseEnabled || $[28] !== isCreateFolderEnabled || $[29] !== isCreateLiveDocEnabled || $[30] !== isCreateSmartLinkEnabled || $[31] !== isCreateWhiteboardEnabled || $[32] !== isOpen || $[33] !== isTreeItem || $[34] !== onCloseHandler || $[35] !== onItemClick || $[36] !== onTriggerClick || $[37] !== parentId || $[38] !== preloadCreationMenu || $[39] !== rootCreateButtonStyling || $[40] !== shouldRenderToParent || $[41] !== source || $[42] !== spaceKey || $[43] !== ssrPlaceholderIdProp) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t8
        }, (pageStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "contextual-create-blanket",
                isTinted: false,
                onBlanketClicked: onCloseHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                isOpen: isOpen,
                onClose: onCloseHandler,
                placement: "bottom-start",
                offset: [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61), {
                        source: source,
                        parentId: parentId,
                        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                        isCreateFolderEnabled: isCreateFolderEnabled && !hideFolder,
                        onCloseMenu: onCloseHandler,
                        pageStateUpdater: pageStateUpdater,
                        onItemClick: onItemClick,
                        parentTitle: displayTitle,
                        parentContentType: contentType
                    }),
                popupComponent: shouldRenderToParent ? $0a7a1bff19d06ba1$var$CustomPopupContainer : undefined,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a7a1bff19d06ba1$var$TriggerContainer, {
                        onClick: handleOnClick,
                        onFocus: stopEvents,
                        onBlur: stopEvents,
                        "data-vc": "contextual-create-content-popover",
                        ...ssrPlaceholderIdProp
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        onMouseEnter: preloadCreationMenu,
                        onFocus: preloadCreationMenu
                    }, isTreeItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c3f789353c0f876$export$eabe3aa0b599cb62), {
                        onClick: enforceStorageLimit(onTriggerClick)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cDCEW.ContextualCreateContentButton), {
                        onClick: enforceStorageLimit(onTriggerClick),
                        triggerProps: triggerProps,
                        isContextualCreateFocused: isContextualCreateFocused,
                        spaceKey: spaceKey,
                        rootCreateButtonStyling: rootCreateButtonStyling,
                        displayTitle: displayTitle
                    })), !shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                        testId: "contextual-create-blanket",
                        isTinted: false,
                        onBlanketClicked: onCloseHandler
                    })),
                shouldRenderToParent: shouldRenderToParent,
                testId: "contextual-create-popover"
            })));
        $[21] = contentType;
        $[22] = displayTitle;
        $[23] = enforceStorageLimit;
        $[24] = handleOnClick;
        $[25] = hideFolder;
        $[26] = isContextualCreateFocused;
        $[27] = isCreateDatabaseEnabled;
        $[28] = isCreateFolderEnabled;
        $[29] = isCreateLiveDocEnabled;
        $[30] = isCreateSmartLinkEnabled;
        $[31] = isCreateWhiteboardEnabled;
        $[32] = isOpen;
        $[33] = isTreeItem;
        $[34] = onCloseHandler;
        $[35] = onItemClick;
        $[36] = onTriggerClick;
        $[37] = parentId;
        $[38] = preloadCreationMenu;
        $[39] = rootCreateButtonStyling;
        $[40] = shouldRenderToParent;
        $[41] = source;
        $[42] = spaceKey;
        $[43] = ssrPlaceholderIdProp;
        $[44] = t9;
    } else t9 = $[44];
    return t9;
};
function $0a7a1bff19d06ba1$var$_temp(event) {
    event.stopPropagation();
    event.preventDefault();
}
module.exports["ContextualCreateContentPopover"] = $0a7a1bff19d06ba1$export$79699783f82a969e;

});

parcelRegister("cDCEW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $b3j2Y = parcelRequire("b3j2Y");


var $jtuBN = parcelRequire("jtuBN");

const $6e1fd29dfbf932de$var$i18n = (0, $cgtv4.defineMessages)({
    simpleCreateLabel: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label",
        defaultMessage: "Create"
    },
    simpleCreateLabelForTitle: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label-for-title",
        defaultMessage: "Create child content for {pageTitle}"
    }
});
const $6e1fd29dfbf932de$var$canCreateContent = (data)=>{
    return (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'page'
    });
};
const $6e1fd29dfbf932de$export$e5aab90af54da00f = (isOpen)=>{
    return isOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)";
};
const $6e1fd29dfbf932de$var$BaseIconButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(5);
    let props;
    if ($[0] !== t0) {
        const { isRootCreateButton: _isRootCreateButton, isOpen: _isOpen, ...t1 } = t0;
        props = t1;
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] !== props || $[3] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...props,
            ref: ref
        });
        $[2] = props;
        $[3] = ref;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides -- To migrate as part of go/ui-styling-standard
const $6e1fd29dfbf932de$var$ContextualCreateButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $6e1fd29dfbf932de$var$BaseIconButton : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_147mbvz": (0, $7sObp.default)($6e1fd29dfbf932de$export$e5aab90af54da00f(__cmplp.isOpen))
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1efsqup9",
                __cmplp.isRootCreateButton ? "_i2zu1q3r" : "_i2zu1kw7",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $6e1fd29dfbf932de$export$613f902834bf164 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { triggerProps: triggerProps, onClick: onClick, isContextualCreateFocused: isContextualCreateFocused, spaceKey: spaceKey, rootCreateButtonStyling: rootCreateButtonStyling, displayTitle: displayTitle } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== spaceKey) {
        t2 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(t1, t2);
    let t3;
    if ($[3] !== onClick) {
        t3 = (e)=>{
            onClick(e);
        };
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const handleClick = t3;
    if (error) {
        let t4;
        if ($[5] !== error) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[5] = error;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const canCreate = data && $6e1fd29dfbf932de$var$canCreateContent(data);
    if (loading || !canCreate) return null;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== intl) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
                size: "small"
            });
        $[8] = intl;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== displayTitle || $[11] !== intl) {
        t6 = displayTitle ? intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabelForTitle, {
            pageTitle: displayTitle
        }) : intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[10] = displayTitle;
        $[11] = intl;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== handleClick || $[14] !== isContextualCreateFocused || $[15] !== rootCreateButtonStyling || $[16] !== t5 || $[17] !== t6 || $[18] !== triggerProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t4,
            position: "top",
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1fd29dfbf932de$var$ContextualCreateButton, {
            ...triggerProps,
            id: "contextual-create-content-button",
            appearance: "subtle",
            icon: t5,
            label: t6,
            onClick: handleClick,
            testId: "contextual-create-content-button",
            isSelected: isContextualCreateFocused,
            isOpen: isContextualCreateFocused,
            isRootCreateButton: rootCreateButtonStyling,
            spacing: "compact"
        }));
        $[13] = handleClick;
        $[14] = isContextualCreateFocused;
        $[15] = rootCreateButtonStyling;
        $[16] = t5;
        $[17] = t6;
        $[18] = triggerProps;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
module.exports["contextualCreateContentIconSVGColor"] = $6e1fd29dfbf932de$export$e5aab90af54da00f;
module.exports["ContextualCreateContentButton"] = $6e1fd29dfbf932de$export$613f902834bf164;

});


//# sourceMappingURL=CreateContentPopover.9d587620.js.map
